const {
  MODE,
  VITE_APP_ROUTE,
  VITE_API_BASE_URL,
  VITE_SENTRY_DSN,
  VITE_ENVIRONMENT,
  VITE_OPS_PANEL_URL,
  VITE_CUSTOMER_APP_URL,
  VITE_DOCS_URL,
} = import.meta.env;

// Use VITE_ENVIRONMENT if set (for staging/production distinction), otherwise fall back to MODE
export const ENV = {
  MODE,
  ENVIRONMENT: VITE_ENVIRONMENT || MODE, // "development", "staging", or "production"
  API_BASE_URL: VITE_API_BASE_URL,
  SENTRY_DSN: VITE_SENTRY_DSN,
  OPS_PANEL_URL: VITE_OPS_PANEL_URL as string | undefined,
  // Public-facing customer app base URL — used to surface storefront links in
  // admin (Settings → Storefront). Backend's CUSTOMER_APP_URL is authoritative
  // for emails / slug-check; this one only feeds the in-admin "open storefront"
  // affordance and falls back to the production default.
  CUSTOMER_APP_URL: (VITE_CUSTOMER_APP_URL as string | undefined) || "https://app.palate.pro",
  // Product documentation site (docs.palate.pro). The backend's
  // /v1/docs/access-token response carries the authoritative docsUrl; this is
  // only a fallback for the /help hand-off if that field is ever absent.
  DOCS_URL: (VITE_DOCS_URL as string | undefined) || "https://docs.palate.pro",
  // hCaptcha PUBLIC site key for the login escalation (backend DEV-B8: after 3
  // failed logins on an email the API demands a `captchaToken`). Must be set
  // together with the backend's HCAPTCHA_SECRET_KEY — a secret without this key
  // leaves users unable to sign in after 3 typos. Read at call time (a getter,
  // not the destructure above) so tests can vary it with vi.stubEnv.
  get HCAPTCHA_SITE_KEY(): string | undefined {
    const key = import.meta.env.VITE_HCAPTCHA_SITE_KEY as string | undefined;
    return key?.trim() || undefined;
  },
};
